import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-new-target',
  templateUrl: './new-target.component.html',
  styleUrls: ['./new-target.component.scss']
})
export class NewTargetComponent implements OnInit {
  @ViewChild('targetTable') targetTable: ElementRef;
  
  selectedLang :any;
  images = [
    // {
    //   previewImageSrc: '../../../assets/home/h-img3.png',
    // },
    {
      previewImageSrc: '../../../assets/home/h-img1.png',
    },
    {
      previewImageSrc: '../../../assets/home/h-img2.png',
    },
    {
      previewImageSrc: '../../../assets/home/h-img4.png',
    },
    {
      previewImageSrc: '../../../assets/home/h-img5.png',
    },
  ];

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  public targetMasterData: any;
  public overFlowPondData: any;
  public canalData: any;
  public stpData: any;
  public cropData: any;
  public loading: boolean = false;

  constructor(
    private translateService: TranslateService,
    public authService: AuthenticationService
  ) {}

  ngOnInit() {
    if(localStorage.getItem('lang')) {
      this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
      this.translateService.use(this.selectedLang .code)
    }

    this.getTargetMasterData();
  }

  languageChange(event) {
   localStorage.setItem('lang', JSON.stringify(event.value))
       this.translateService.use(event.value.code);
  }

  getTargetMasterData() {
    this.loading = true;
    this.authService.getTargetMasterPublic().subscribe((response: any) => {
      this.loading = false;
      if(response.$values && response.$values.length > 0){
        
        if(response.$values[0] && response.$values[0].$values.length > 0){
          this.canalData = response.$values[0].$values;
          this.canalData = response.$values[0].$values.filter(val => val.Type == 'Canal');
          this.stpData = response.$values[0].$values.filter(val => val.Type == 'STP');
          this.canalData.forEach((val, index) => 
          val['SNo'] = index + 1
          )
          this.stpData.forEach((val, index) => 
          val['SNo'] = index + 1
          )
        }
  
        if(response.$values[1] && response.$values[1].$values.length > 0){
          this.overFlowPondData = response.$values[1].$values;
          this.overFlowPondData.forEach((val, index) => 
          val['SNo'] = index + 1
          )
        }
  
        if(response.$values[2] && response.$values[2].$values.length > 0){
          this.cropData = response.$values[2].$values;
          this.cropData.forEach((val, index) => 
          val['SNo'] = index + 1
          )
        }

      }

    });
  }
}
